import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useHistory, useParams } from "react-router";

import { PATH_HOME } from "@configs";
import { setSelelrId } from "@redux";
import CacheStore from "@Rocket-Innovation/components/store/CacheStore";

export const PageInviteBySeller = () => {
    const { id } = useParams<{ id: string }>();
    const dispatch = useDispatch();
    const history = useHistory();
    useEffect(() => {
        if (id) {
            dispatch(setSelelrId(id));

            //Update in Rocket-Innovation's components
            CacheStore.setState({
                appendFields: {
                    ...CacheStore.getState().appendFields,
                    sellerId: id,
                },
            });

            history.push(PATH_HOME);
        }
    }, [id]);
    return <></>;
};
